import React from 'react';
import { ELIGIBILITY } from '@tmap/mmm-core/commonApp/funnelCategories';
import CommonApp from '../../components/commonApp';
import Metatags from '../../components/metatags';
import FullWrapper from '../../layouts/fullWrapper';

function Eligibility() {
  return (
    <>
      <Metatags
        title='Verify Requirements'
        description=''
        canonical={`${process.env.NEXT_PUBLIC_CANONICAL_DOMAIN}/apply/eligibility`}
      />
      <CommonApp stage={ELIGIBILITY} />
    </>
  );
}

Eligibility.getLayout = function getLayout(page) {
  return <FullWrapper>{page}</FullWrapper>;
};

export default Eligibility;
